<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <!-- <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="finalizeAnalysis"
                            :loading="dataForm.addLoading"
                            v-if="!page.isNew && $check(user, ['officioanalysis.finalize', 'officioanalysis.*', '*'])">Finalizar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading"
                            v-if="page.isNew && $check(user, ['officioanalysis.create', 'officioanalysis.create.*', 'officioanalysis.*', '*'])">Criar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading"
                            v-if="!page.isNew && $check(user, ['officioanalysis.update', 'officioanalysis.update.*', 'officioanalysis.*', '*'])">Salvar</v-btn> -->
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/analise-oficio">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense id="name" label="Nome completo"
                                                v-model="dataset.data.name" outlined hide-details="auto"
                                                :disabled="isDisabled">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="CPF/CNPJ" v-model="dataset.data.registration"
                                                outlined hide-details="auto" @input="formatRegistration"
                                                :disabled="isDisabled">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-select dense id="type"
                                                :items="dataset.currencyTypes" label="Moeda"
                                                v-model="dataset.data.currency" item-value="id" item-text="name"
                                                 outlined hide-details="auto"
                                                :disabled="isDisabled"></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-currency-field label="Valor" dense v-model="dataset.data.amount"
                                                hide-details="auto" outlined required
                                                :disabled="isDisabled">
                                            </v-currency-field>
                                        </v-col>

                                    </v-row>

                                    <v-row>

                                        <v-col cols="12" sm="6">
                                            <v-select dense :items="dataset.creditorTypes" label="Classe"
                                                v-model="dataset.data.type" item-value="id" item-text="name" outlined
                                                hide-details="auto" :disabled="isDisabled">
                                            </v-select>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Prazo contraditório"
                                                :value="formatDate(dataset.data.contradictory_deadline_at)"
                                                @input="updateContraditory" outlined hide-details="auto" :disabled="isDisabled">
                                            </v-text-field>
                                        </v-col>

                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-autocomplete dense required
                                                :items="dataset.creditorOriginTypes"
                                                label="Origem do crédito" v-model="dataset.data.origin"
                                                item-value="name" item-text="name" outlined
                                                hide-details="auto" :disabled="isDisabled"></v-autocomplete>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <template v-if="dataset.data.amount && dataset.data.reason">
                                                <v-card class="pa-4" elevation="3">
                                                    <v-card-title class="card-group-title">
                                                      Motivo
                                                    </v-card-title>
                                              
                                                    <v-divider class="mb-3"></v-divider>
                                              
                                                    <v-card-text>
                                                      <!-- <p><strong>Valor:</strong> {{ dataset.data.amount | currency }}</p> -->
                                                      <p><span v-html="dataset.data.reason"></span></p>
                                                    </v-card-text>
                                                </v-card>
                                            </template>
                                              
                                            <v-alert v-else type="info" outlined>
                                                  Nenhum informação de motivo disponível.
                                            </v-alert> 
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Credor Associado</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-list-item dense v-if="dataset.modalResult.name">
                                                <v-list-item-avatar>
                                                    <v-icon size="32">mdi-account-outline</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title> {{ dataset.modalResult.name
                                                    }}</v-list-item-title>
                                                    <v-list-item-subtitle> {{ dataset.modalResult.client.name
                                                    }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item dense v-else>
                                                <v-list-item-avatar>
                                                    <v-icon size="32">mdi-account-outline</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>Nenhum credor associado a esta
                                                        análise</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-col>
                                    </v-row>
                                    <!-- <v-row>
                                        <v-col>
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn v-on="on" @click="openCreditorSelectionModal(dataset.data)"
                                                        color="primary" dark elevation="2" small>
                                                        {{ dataset.modalResult.name ? 'Alterar' : 'Associar' }}
                                                    </v-btn>
                                                </template>
                                                <span>{{ dataset.modalResult.name ? 'Alterar credor' : 'Associar credor'
                                                }}</span>
                                            </v-tooltip>

                                            <template v-if="dataset.modalResult.name">
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn v-on="on" @click="removeAssociation(dataset.data)"
                                                            color="primary" dark elevation="2" small class="ml-5">
                                                            Remover
                                                        </v-btn>
                                                    </template>
                                                    <span>Remover associação da análise com o credor</span>
                                                </v-tooltip>
                                            </template>
                                        </v-col>
                                    </v-row> -->
                                </v-card-text>
                            </v-card>
                        </v-col>

                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <!-- <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Documento apoio</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-file-input dense accept="image/png, image/jpeg, application/pdf"
                                            prepend-icon="" outlined counter
                                            hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                                            label="Documento" :clearable="true" @change="onFileSelected($event)"
                                            show-size truncate-length="50" ref="file">
                                        </v-file-input>

                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-card-text>

                                <template>
                                    <v-row class="mt-n5">
                                        <v-col cols="12">
                                            <v-btn type="button" elevation="0" color="primary" outlined
                                                v-if="dataset.data.help_doc_url" :href="dataset.data.help_doc_url"
                                                target="_blank">Visualizar
                                                documento
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-card-text>

                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row> -->

        <!-- <v-dialog v-model="dialogDynamicText" :width="900">
            <v-card :max-height="700">
                <v-card-text>
                    <v-row>
                        <v-col>
                            <div class="font-weight-bold mt-6 title-page">Textos Automáticos</div>
                            <p class="mt-2">
                                Selecione um texto abaixo para adicionar na análise
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div>
                                <v-list-item v-for="(item, index) in dataset.dynamicTexts" :key="index"
                                    style="cursor: pointer" @click="selectDynamicText(item)">
                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                                        <v-list-item-subtitle>
                                            <div
                                                v-html="dynamicTextSmallType ? item.small_description : truncateText(item.description, 150)">
                                            </div>
                                            <v-divider></v-divider>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </div>
                            <v-card class="rounded-lg mb-10" v-for="(item, index) in dataset.dynamicTexts" :key="index"
                                elevation="2">
                                <v-card-title>
                                    {{ item.name }}
                                </v-card-title>
                                <v-card-text>
                                    <div v-html="dynamicTextSmallType ? item.small_description : item.description"></div>
                                </v-card-text>
                            </v-card> 
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-btn type="button" elevation="0" color="error"
                                @click="dialogDynamicText = false;">Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog> -->


    </v-container>
</template>

<script>

import string from "@/common/util/string"

import axios from "axios"

import { eventHub } from "@/main";

//import incidentTypesList from "@/common/data/incident-types.data"
import currencyTypes from "@/common/data/currency-types.data"
import creditorTypes from "@/common/data/creditor-types.data"
import creditorOriginTypes from "@/common/data/creditor-origin-types.data.js";
import { cpf, cnpj } from 'cpf-cnpj-validator'


export default {
    name: "OfficioAnalysisDetails",

    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        isDisabled: true,
        dataset: {
            breadcrumbItems: [],
            dynamicTexts: [],
            data: {
                contradictory_deadline_at: null,
                helpDocument: null,
                qgc_excluded: false,
            },
            //incidentTypesList: incidentTypesList,
            currencyTypes: currencyTypes,
            creditorTypes: creditorTypes,
            creditorOriginTypes: creditorOriginTypes,
            modalResult: {
                name: null,
                client: { name: null }

            },
        },
        //dialogAnalysisCreditorSelection: false,
        dynamicTextSmallType: false,
        dialogDynamicText: false,
        selectedDoc: null,
        dialogViewDoc: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
        // extensions: [
        //     Underline,
        //     Strike,
        //     Italic,
        //     Bold,
        //     Paragraph,
        // ],
    }),

    // watch: {
    //     "dataset.modalResult.name"() {
    //         this.dataset.modalResult.name ? this.isDisabled = true : this.isDisabled = false
    //     },
    // },

    created() {
        this.loadData()
    },


    methods: {

        goBack() {
            this.$router.replace("/analise-oficio");
        },

        async loadData() {
            this.setPage();
           // this.checkPermissions();
            this.listBreadCrumbItems();
            await this.load();
        },

        // openDialogDynamicText(small = false) {
        //     this.loadDynamicTexts()

        //     this.dynamicTextSmallType = small;
        //     this.dialogDynamicText = true;

        // },

        formatRegistration(registration) {

            if (registration) {
                this.dataset.data.registration = registration.length < 14 ? cpf.format(registration) : cnpj.format(registration);
            }
        },

        onFileSelected(file) {
            this.dataset.data.helpDocument = file;
        },

        async removeAssociation() {

            if (!this.dataset.modalResult.name) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja remover o credor associado?',
                title: 'Remover credor',
                actions: {
                    false: 'Cancelar',
                    true: 'Remover'
                }
            })

            if (!proceedAction) return;

            this.dataset.modalResult.name = null;
            this.dataset.modalResult.client.name = null;

        },

        formatDate(date) {
            if (!date || date === "0000-00-00 00:00:00") return null;
            return this.$moment(date).format('YYYY-MM-DD');
        },

        updateContraditory(value) {
            this.dataset.data.contradictory_deadline_at = value;
        },

        setPage() {
            this.page.title = 'Detalhes da análise';
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Análise de oficio",
                disabled: false,
                to: "/analise-oficio",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        truncateText(text, maxLength) {
            if (!text || typeof text !== 'string') {
                return '';
            }

            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        },


        async loadDynamicTexts() {

            try {
                const result = await axios.get(`/api/admin/dynamic-texts`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.dynamicTexts = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        selectDynamicText(item) {
            if (this.dynamicTextSmallType) {
                this.dataset.data.smallReason += item.small_description
            } else {
                this.dataset.data.reason += item.description
            }

            this.dialogDynamicText = false;
        },


        async openCreditorSelectionModal(item) {

            if (this.dataset.data.name) {
                this.$dialog.notify.error("Já existe um nome de credor associado!", { position: "top-right", timeout: 3000 });
                return;
            }

            this.$refs.AnalysisCreditorSelectionModalRef.setData(item);

            this.$refs.AnalysisCreditorSelectionModalRef.open().then((results) => {

                if (!results) {
                    return
                }

                this.dataset.modalResult = results

            });

        },

        async load() {

            try {
                const result = await axios.get(`/api/admin/officio-analysis/${this.$route.params.id}`);
                console.log('result ', result)

                const data = result.data.content;

                this.dataset.data = data;

                if (data) {
                    this.dataset.modalResult.name = data.userCreditor.name;

                    const registration = this.dataset.data.registration;

                    if (registration) {
                        this.dataset.data.registration = registration.length < 14 ? cpf.format(registration) : cnpj.format(registration);
                    }

                    console.log("CPF: ", this.dataset.data.registration)

                    const client_id = data.userCreditor.client_id

                    try {
                        const result = await axios.get(`/api/clients/${client_id}`);

                        const data = result.data.content;

                        this.dataset.modalResult.client.name = data.name

                    } catch (error) {
                        this.$dialog.notify.error(this.$codes(error), {
                            position: 'top-right',
                            timeout: 2000
                        })
                    }

                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        async add() {

            if (!this.dataset.modalResult.name && !this.dataset.data.name) {
                this.$dialog.notify.error("Credor não informado!", { position: "top-right", timeout: 3000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir a análise?',
                title: 'Incluir análise',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/admin/officio-analysis', payload);

                this.$dialog.notify.info("Análise salva com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async finalizeAnalysis() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja finalizar a análise?',
                title: 'Finalisar análise',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            // this.dataForm.addLoading = true;

            // const payload = this.buildPayload();

            // try {
            //     const response = await axios.post('/api/admin/official-letters', payload);

            //     this.$dialog.notify.info("Análise salva com sucesso!", { position: "top-right", timeout: 2000 });

            //     this.goBack()
            // } catch (error) {
            //     this.$dialog.notify.error(this.$codes(error), {
            //         position: 'top-right',
            //         timeout: 2000
            //     })
            // } finally {
            //     this.dataForm.addLoading = false;
            // }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados da análise?',
                title: 'Atualizar análise',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/admin/officio-analysis/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Análise atualizada com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },


        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.contradictory_deadline_at)
                formData.append('contradictory_deadline_at', this.dataset.data.contradictory_deadline_at);

            if (this.dataset.data.amount)
                formData.append('amount', this.dataset.data.amount);

            if (this.dataset.data.currency)
                formData.append('currency', this.dataset.data.currency);

            if (this.dataset.data.name)
                formData.append('name', this.dataset.data.name);

            if (this.dataset.data.registration)
                formData.append('registration', this.dataset.data.registration.replace(/\D/g, ''));

            if (this.dataset.data.type)
                formData.append('type', this.dataset.data.type);

            if (this.dataset.data.origin)
                formData.append('origin', this.dataset.data.origin);

            if (this.dataset.data.reason)
                formData.append('reason', this.dataset.data.reason);

            if (this.dataset.modalResult.id)
                formData.append('user_creditor_id', this.dataset.modalResult.id)

            if (this.dataset.data.helpDocument)
                formData.append('file', this.dataset.data.helpDocument)

                return formData;
        },

        async saveExcludeFromQgc() {

            const isQgcExcluded = this.dataset.data.qgc_excluded;

            const proceedAction = await this.$dialog.confirm({
                text: isQgcExcluded
                    ? 'Tem certeza que deseja excluir do QGC?'
                    : 'Tem certeza que deseja manter no QGC?',
                title: isQgcExcluded ? 'Excluir do QGC' : 'Manter no QGC',
                actions: {
                    false: 'NÃO',
                    true: 'SIM',
                },
            });

            if (!proceedAction) {
                this.dataset.data.qgc_excluded = !isQgcExcluded;
                return;
            }

            const payload = { qgc_excluded: isQgcExcluded };

            try {
                await axios.patch(`/api/admin/officio-analysis/excluded-from-qgc/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Alteração efetuada com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });
            } catch (error) {
                this.dataset.data.qgc_excluded = !isQgcExcluded;

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.custom-editor-short {
    .tiptap-vuetify-editor__content {
        min-height: 100px !important;
    }

    .ProseMirror {
        min-height: 100px !important;
    }
}

.custom-editor-long {
    .tiptap-vuetify-editor__content {
        min-height: 200px !important;
    }

    .ProseMirror {
        min-height: 200px !important;
    }
}
</style>